module.exports = __webpack_public_path__ + "img/20190819160940501.dba58960.png";